interface ITableButtonsHeaderProps {
  children: React.ReactNode;
  justifyContent?: 'space-between' | 'end';
  /** Override bottom margin; defaults to 8px everywhere except MAT grid where we pass 0 */
  marginBottom?: number | string;
  /** Override top margin; defaults to 10px (set 0 for dense header rows) */
  marginTop?: number | string;
}

const TableButtonsHeader = ({
  children,
  justifyContent = 'space-between',
  marginBottom = 8,
  marginTop = 10,
}: ITableButtonsHeaderProps) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: justifyContent,
        marginBottom,
        marginTop,
        gap: '8px',
      }}
    >
      {children}
    </div>
  );
};

export default TableButtonsHeader;
